import offsets from './res/cosmetic-offsets.json';

WL.registerComponent('body-slots', {
  bodyParts: { type: WL.Type.Object },
  head: { type: WL.Type.Object },
  body: { type: WL.Type.Object }
}, {
  init: function() {
  },
  start: function() {
    this.mouth = this.head.children.find(child => child.name === 'mouthAnchor');
    this.eyes = this.head.children.find(child => child.name === 'eyeAnchor');
    this.hat = this.head.children.find(child => child.name === 'hatAnchor');
  },
  setHat: function(hatType) {
    const hats = this.bodyParts.children.find(child => child.name === 'Hats');
    const hat = hats.children.find(child => child.name === hatType);
    const hatMesh = hat.getComponent('mesh');
    this.cloneBodyPart(hat, hatMesh, this.hat);
    this.applyOffset('hat', hatType);
  },
  setHead: function(headType) {
    const heads = this.bodyParts.children.find(child => child.name === 'Heads');
    const head = heads.children.find(child => child.name === headType);
    const headMesh = head.getComponent('mesh');
    const newHead = this.cloneBodyPart(head, headMesh, this.head);
    this.cloneAnchors(head, newHead);
    this.applyOffset('head', headType);
  },
  setMouth: function(mouthType) {
    const mouths = this.bodyParts.children.find(child => child.name === 'Mouths');
    const mouth = mouths.children.find(child => child.name === mouthType);
    const mouthMesh = mouth.getComponent('mesh');
    console.log(this.mouth.getTranslationLocal([]));
    this.cloneBodyPart(mouth, mouthMesh, this.mouth);
    this.applyOffset('mouth', mouthType);
  },
  setEyes: function(eyeType) {
    const eyes = this.bodyParts.children.find(child => child.name === 'Eyes');
    const eye = eyes.children.find(child => child.name === eyeType);
    const eyeMesh = eye.getComponent('mesh');
    this.cloneBodyPart(eye, eyeMesh, this.eye);
    this.applyOffset('eyes', eyeType);
  },
  setBody: function(bodyType) {
    const bodies = this.bodyParts.children.find(child => child.name === 'Bodies');
    const body = bodies.children.find(child => child.name === bodyType);
    const bodyMesh = body.getComponent('mesh');
    this.cloneBodyPart(body, bodyMesh, this.body);
    this.applyOffset('body', bodyType);
  },
  applyOffset: function(object, name) {
    try {
      this[object].translate(offsets[name].position);
      this[object].rotate(offsets[name].rotation);
    } catch {
      console.log(`Unable to find offset values for ${name}: check if entry exists in offsets file.`);
    }
  },
  cloneBodyPart: function(part, mesh, parent) {
    const newPart = WL.scene.addObject(parent);
    newPart.scalingLocal = part.scalingLocal;
    const newPartMesh = newPart.addComponent('mesh');
    newPartMesh.mesh = mesh.mesh;
    newPartMesh.material = mesh.material.clone();
    return newPart;
  },
  cloneAnchors: function(head, newHead) {
    const hatAnchor = head.children.find(child => child.name === 'hatAnchor');
    const newHatAnchor = WL.scene.addObject(newHead);
    newHatAnchor.setTranslationLocal(hatAnchor.getTranslationLocal([]));
    newHatAnchor.scalingLocal = hatAnchor.scalingLocal;
    this.hat = newHatAnchor;
    
    const eyeAnchor = head.children.find(child => child.name === 'eyeAnchor');
    const newEyeAnchor = WL.scene.addObject(newHead);
    newEyeAnchor.setTranslationLocal(eyeAnchor.getTranslationLocal([]));
    newEyeAnchor.scalingLocal = eyeAnchor.scalingLocal;
    this.eye = newEyeAnchor;

    const mouthAnchor = head.children.find(child => child.name === 'mouthAnchor');
    const newMouthAnchor = WL.scene.addObject(newHead);
    newMouthAnchor.setTranslationLocal(mouthAnchor.getTranslationLocal([]));
    newMouthAnchor.scalingLocal = mouthAnchor.scalingLocal;
    this.mouth = newMouthAnchor;
  }
});